import { erpLabel } from "../lib/format";

const STATUS_STYLES = {
  paid: "badge-success",
  pending: "badge-warning",
  overdue: "badge-error",
  draft: "badge-neutral",
  synced: "badge-success",
  failed: "badge-error",
};

export function StatusBadge({ value, testid }) {
  const cls = STATUS_STYLES[value] || "badge-neutral";
  return (
    <span className={`badge ${cls}`} data-testid={testid}>
      <span className="status-dot" style={{ background: "currentColor" }} />
      {value}
    </span>
  );
}

export function ErpBadge({ erp, testid }) {
  return (
    <span className="badge badge-info" data-testid={testid}>
      {erpLabel(erp)}
    </span>
  );
}

export function SyncArrow({ from, to, testid }) {
  return (
    <span className="inline-flex items-center gap-2 text-xs" data-testid={testid}>
      <span className="font-mono text-neutral-900">{erpLabel(from)}</span>
      <span className="text-neutral-400">→</span>
      <span className="font-mono text-neutral-900">{erpLabel(to)}</span>
    </span>
  );
}
